import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import { TRACK_ELEMENT } from '../../constants/track';
import { formatMarketplaceQualityCount } from './utils';
import styles from './marketplaceRegistrationQuality.module.scss';

const TAG_VARIANT_CLASS = {
  critical: styles.tagCritical,
  warning: styles.tagWarning,
  positive: styles.tagPositive,
  info: styles.tagInfo,
};

function MarketplaceRegistrationQualityRow({
  level,
  locale,
  onClick,
  trackCallback = null,
}) {
  const isClickable = Boolean(level.url);

  const handleClick = () => {
    if (!isClickable) return;

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }

    if (onClick) {
      onClick(level);
    }
  };

  return (
    <Box
      className={styles.row}
      data-clickable={isClickable}
      onClick={handleClick}
    >
      <Text
        className={`${styles.tag} ${
          TAG_VARIANT_CLASS[level.variant] || ''
        }`.trim()}
      >
        {Trans(translations, level.translationKey)}
      </Text>
      <Box className={styles.countBadge}>
        <Icon icon="icon-propiedades" className={styles.countIcon} />
        <Text className={styles.count}>
          {formatMarketplaceQualityCount(level.count, locale)}
        </Text>
      </Box>
    </Box>
  );
}

export default MarketplaceRegistrationQualityRow;
